import { render, staticRenderFns } from "./cg-stage-sponsor-image.vue?vue&type=template&id=20bd9324&scoped=true"
import script from "./cg-stage-sponsor-image.vue?vue&type=script&lang=js"
export * from "./cg-stage-sponsor-image.vue?vue&type=script&lang=js"
import style0 from "./cg-stage-sponsor-image.vue?vue&type=style&index=0&id=20bd9324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bd9324",
  null
  
)

export default component.exports